export const clockOutQuotes = [
  "The secret of getting ahead is getting started.",
    "Focus on being productive instead of busy.",
    "Success usually comes to those who are too busy to be looking for it.",
    "Well begun is half done.",
    "The only way to do great work is to love what you do.",
    "Don't watch the clock; do what it does. Keep going.",
    "Strive not to be a success, but rather to be of value.",
    "Do what you can, with what you have, where you are.",
    "Act as if what you do makes a difference. It does.",
    "Your time is limited, don't waste it living someone else's life.",
    "Dream big and dare to fail.",
    "The only place where success comes before work is in the dictionary.",
    "Hard work beats talent when talent doesn’t work hard.",
    "The harder you work for something, the greater you'll feel when you achieve it.",
    "Don’t stop when you’re tired. Stop when you’re done.",
    "Start where you are. Use what you have. Do what you can.",
    "Success is the sum of small efforts, repeated day in and day out.",
    "Success isn’t always about greatness. It’s about consistency.",
    "The best way to predict the future is to create it.",
    "Don’t wait for opportunity. Create it.",
    "Work hard in silence; let success make the noise.",
    "The harder the battle, the sweeter the victory.",
    "Success usually comes to those who are too busy to be looking for it.",
    "The road to success and the road to failure are almost exactly the same.",
    "Don’t be afraid to give up the good to go for the great.",
    "Success is not how high you have climbed, but how you make a positive difference to the world.",
    "Success is not final, failure is not fatal: It is the courage to continue that counts.",
    "Success is the result of preparation, hard work, and learning from failure.",
    "Success is not in what you have, but who you are.",
    "Success means doing the best we can with what we have.",
    "Opportunities don't happen. You create them.",
    "If you want to achieve greatness stop asking for permission.",
    "Just because something doesn’t do what you planned it to do doesn’t mean it’s useless.",
    "Perseverance is failing 19 times and succeeding the 20th.",
    "I find that the harder I work, the more luck I seem to have.",
    "Success isn’t overnight. It’s when every day you get a little better than the day before. It all adds up.",
    "The way to get started is to quit talking and begin doing.",
    "Your work is going to fill a large part of your life, and the only way to be truly satisfied is to do what you believe is great work.",
    "The difference between ordinary and extraordinary is that little extra.",
    "You don’t have to be great to start, but you have to start to be great.",
    "Success is not the key to happiness. Happiness is the key to success.",
    "Opportunities are usually disguised as hard work, so most people don’t recognize them.",
    "Work gives you meaning and purpose and life is empty without it.",
    "There is no substitute for hard work.",
    "It’s not about ideas. It’s about making ideas happen.",
    "Every day is a new opportunity to begin again. Every day is your birthday.",
    "Good things come to people who wait, but better things come to those who go out and get them.",
    "Work hard and be kind and amazing things will happen.",
    "Success is doing ordinary things extraordinarily well.",
    "The man who moves a mountain begins by carrying away small stones.",
    "Good Job!",
    "Rest and recharge; you've earned it.",
    "Well done! Enjoy your time off.",
    "You did great today!",
    "Celebrate small victories, they lead to bigger ones.",
    "Take time to do what makes your soul happy.",
    "Relax, refresh, and recharge.",
    "Time to relax and reflect.",
    "The end of a great workday is a reason to smile.",
    "You’ve worked hard, now take a break.",
    "Enjoy the rest of your day; you’ve earned it.",
    "The best time for relaxation is now.",
    "Taking time to do nothing often brings everything into perspective.",
    "Rest and be thankful.",
    "It’s time to rest and renew.",
    "Work hard, rest well, repeat.",
    "The sun sets to rise again; enjoy your evening.",
    "Your mind will answer most questions if you learn to relax and wait for the answer.",
    "Rest is not idleness, and to lie sometimes on the grass under trees on a summer’s day, listening to the murmur of the water, or watching the clouds float across the sky, is by no means a waste of time.",
    "Sometimes the most productive thing you can do is relax.",
    "Time to unwind and let go of the day.",
    "Take a deep breath, you’ve made it through the day.",
    "It’s time to put your feet up and relax.",
    "There is virtue in work and there is virtue in rest. Use both and overlook neither.",
    "Enjoy the evening, you’ve earned it.",
    "Rest, relax, and recharge for tomorrow.",
    "End the day with gratitude; you’ve done your best.",
    "The time to relax is when you don't have time for it.",
    "Unplug and relax; work will wait.",
    "Rest isn’t idle, it’s work too. It’s the effort we put into recharging ourselves.",
    "End the day strong by acknowledging your achievements.",
    "Time to switch off and enjoy some leisure.",
    "You’ve worked hard; now it’s time to relax.",
    "Finish your workday knowing you’ve done your best.",
    "The best way to unwind is to do what makes you happy.",
    "Rest is a key ingredient to work well.",
    "End the day on a positive note; tomorrow is another opportunity.",
    "Take a break and savor your accomplishments.",
    "Rest is not idle; it’s the doorway to the soul.",
    "Relaxation is the art of letting go of daily stresses.",
    "You’ve given it your all; now give yourself some rest.",
    "A day well spent brings a night of content.",
    "Put your feet up and reflect on a job well done.",
    "The reward for work well done is the opportunity to do more, but now, rest.",
    "Take a moment to appreciate all that you’ve achieved today.",
    "Switch off, unwind, and recharge.",
    "Rest and self-care are so important. Take time to replenish your energy.",
    "Relax and recharge; you’ve done a fantastic job."
];
  
export const getRandomQuote = (quotesArray) => {
  const randomIndex = Math.floor(Math.random() * quotesArray.length);
  return quotesArray[randomIndex];
};
  